import styled from "styled-components"
import View from "./View"

export default styled(View)`
  display: flex;
  flex-direction: column;
`
// min-height: ${({ root }) => (!root ? "100%" : "100vh")};
